import type { TDiscoverySubType } from '../interfaces/IAiChatTools';

/**
 * Translation key of the agent a session runs, for the agent session rows. A sub-type the FE
 * does not know reads as supplier discovery.
 */
const readAgentSubTypeKey = (subType: TDiscoverySubType | undefined): string => (
  subType === 'bill-of-materials' ? 'aiChat.tools.agentBillOfMaterials' : 'aiChat.tools.agentSupplierDiscovery'
);

export default readAgentSubTypeKey;
